export const flags = state => state.flags
export const dadosRetorno = state => state.dadosRetorno
export const carregandoDados = state => state.flagsDeControle.carregandoDados
export const manipulandoDados = state => state.flagsDeControle.manipulandoDados
